import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
Vue.use(VueRouter)
import http from '../api/index'
import {
	message
} from 'ant-design-vue'
let routes = [{
	// will match everything
	path: '*',
	component: () => import('../views/404.vue'),
},
{
	path: '/',
	name: 'Home',
	redirect: '/dashboard',
},
{
	path: '/dashboard',
	name: 'Dashboard',
	layout: "dashboard",
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: () => import( /* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
	meta: {
		title: "工作台"
	}
},
{
	path: '/layout',
	name: 'Layout',
	layout: "dashboard",
	component: () => import('../views/Layout.vue'),
},
{
	path: '/tables',
	name: 'Tables',
	layout: "dashboard",
	component: () => import('../views/Tables.vue'),
},
{
	path: '/billing',
	name: 'Billing',
	layout: "dashboard",
	component: () => import('../views/Billing.vue'),
},
{
	path: '/rtl',
	name: 'RTL',
	layout: "dashboard-rtl",
	meta: {
		layoutClass: 'dashboard-rtl',
	},
	component: () => import('../views/RTL.vue'),
},
{
	path: '/Profile',
	name: 'Profile',
	layout: "dashboard",
	meta: {
		layoutClass: 'layout-profile',
	},
	component: () => import('../views/Profile.vue'),
},
{
	path: '/sign-in',
	name: 'Sign-In',
	component: () => import('../views/Sign-In.vue'),
},
{
	path: '/sign-up',
	name: 'Sign-Up',
	meta: {
		layoutClass: 'layout-sign-up',
	},
	component: () => import('../views/Sign-Up.vue'),
}
]

export const loadView = (view) => {
	return (resolve) => require([`@/views/${view}`], resolve)
};

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute(route, parentLayout = "default") {
	route.meta = route.meta || {};
	route.meta.layout = route.layout || parentLayout;

	if (route.children) {
		route.children = route.children.map((childRoute) => addLayoutToRoute(childRoute, route.meta.layout));
	}
	return route;
}

routes = routes.map((route) => addLayoutToRoute(route));


const createRouter = () => new VueRouter({
	mode: 'hash',
	// base: process.env.BASE_URL,
	base: '/admin', //指定路由前缀
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	}
})


const router = createRouter();

function addDynamicRoutes(routers) {
	let addroutes = routers.filter(v => !!v.component).map(v => {
		return {
			path: v.path,
			name: v.name,
			layout: "dashboard",
			component: loadView(v.component),
			meta: {
				title: v.title,
				keepalive: v.keepalive,
				hiden: v.hiden == 0 ? false : true
			}
		}
	})
	addroutes = addroutes.map((route) => addLayoutToRoute(route));
	console.log(addroutes)
	addroutes.map(v => router.addRoute(v))
	return addroutes;
}

// 路由拦截
router.beforeEach(async (to, from, next) => {
	// 如果是登录页，直接跳过拦截
	if (to.path === '/sign-in') return next();

	const menuRouter = store.state.menuRouter;
	const token = store.state.token;

	// 如果没有 token，重定向到登录页
	if (!token) {
		return next('/sign-in');
	} else {
		// 如果没有菜单路由，获取用户信息并动态添加路由
		if (!menuRouter) {
			try {
				const info = await http({
					url: '/admin/sys/userinfo',
					method: 'get',
				});
				const newRouter = createRouter();
				router.matcher = newRouter.matcher; // 重置路由的匹配器
				// 保存用户信息和权限路由
				store.commit('setUserinfo', info.data);
				store.commit('setMenuRouter', info.data.menu_power);
				store.commit('setButtonPower', info.data.button_power.map(v => v.power));
				// 动态添加路由
				addDynamicRoutes(info.data.menu_list);
				// 确保路由添加完成后重试导航
				next({
					...to,
					replace: true
				});
			} catch (e) {
				debugger
				return next('/sign-in');
			}
		} else {
			// 菜单已经存在，直接放行
			next();
		}
	}
});


export default router